import Client from 'modules/Client'

export default {
  queryCep (value) {
    const cep = value.replace(/\D/g, '')
    return Client.get('api/utils/cep', { params: { cep } })
      .then(response => response.data)
  }
}
